import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';
import {
  logDevError,
  updateErrorMessage,
  updateSuccessMessage,
} from 'shared/alerts';

export const UPDATE_POS_SETTINGS = gql`
  mutation UpdatePOSSettings($input: UpdatePOSSettings!) {
    updatePOSSettings(input: $input)
  }
`;

export function useUpdatePOSSettings() {
  const [updatePOSSettingsMutation] = useMutation(UPDATE_POS_SETTINGS);

  const updatePOSSettings = useCallback(
    async (input) => {
      try {
        await updatePOSSettingsMutation({
          variables: { input },
          onCompleted: () => updateSuccessMessage('POS Settings'),
          onError: () => updateErrorMessage('POS Settings'),
        });
      } catch (error) {
        logDevError(error);
        updateErrorMessage('POS Settings');
      }
      return true;
    },
    [updatePOSSettingsMutation]
  );
  return updatePOSSettings;
}
